document.addEventListener("DOMContentLoaded", () => {
  AddToCartText();
  FlavorOption();
  const productRatings = document.querySelector(".questions-tab");
  if (!productRatings) return;

  function showRatings() {
    productRatings.style.visibility = "visible";
  }

  const waitForNavBar = setInterval(function () {
    const navBar = document.querySelector(".oke-w-navBar");
    if (navBar) {
      clearInterval(waitForNavBar);
      setTimeout(showRatings, 2500);
      const questionsTab = document.querySelector("a.questions-tab");
      var tabButtons3 = document.querySelectorAll('div[role="tablist"] button');
      const contentElement = tabButtons3[1].querySelector(
        ".oke-w-navBar-item-count"
      );
      const content = contentElement ? contentElement.textContent : null;

      if (content !== null && typeof content !== "undefined") {
        if (parseInt(content) === 1) {
          questionsTab.innerHTML = content + " Question";
        } else {
          questionsTab.innerHTML = content + " Questions";
        }
      } else {
        questionsTab.innerHTML = "Ask a Question";
      }
    }
  }, 200);
});

document.addEventListener("DOMContentLoaded", function () {
  // Event delegation for opening the popup
  document.addEventListener("click", function (event) {
    if (event.target.classList.contains("popup-link")) {
      event.preventDefault();
      var popup = event.target
        .closest(".popup-container")
        .querySelector(".popup");
      var main = document.querySelector("main");
      if (popup) {
        popup.style.display = "flex";
        document.documentElement.style.overflow = "hidden";
        main.style.zIndex = "700";
      }
    }
  });

  // Event delegation for closing the popup
  document.addEventListener("click", function (event) {
    if (
      event.target.classList.contains("popup-close") ||
      event.target.classList.contains("popup")
    ) {
      var popup = event.target.closest(".popup");
      var main = document.querySelector("main");
      if (
        popup &&
        (event.target.classList.contains("popup-close") ||
          event.target == popup)
      ) {
        popup.style.display = "none";
        document.documentElement.style.overflow = "";
        main.style.zIndex = "500";
      }
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const productContainer = document.querySelector(
    ".product__container[data-product-wrapper]"
  );
  if (!productContainer) return;

  const optionName =
    productContainer.dataset.hideVariants === "true"
      ? "Flavor"
      : "Quantity";
  const optionLabel = document.querySelector(
    `.options-selection__select-label[data-variant-option-name="${optionName}"]`
  );
  const node = document.querySelector(
    productContainer.dataset.hideVariants === "true"
      ? ".product--outer .product-form--atc .product-form__action-wrapper .product-form__action-wrapper-inner"
      : ".product--outer .product-form--atc"
  );

  if (!optionLabel || !node) return;

  const elem = optionLabel.closest(".options-selection__select-wrapper");
  if (!elem) return;

  node.insertAdjacentElement("afterbegin", elem);
});

document.body.addEventListener("click", function (e) {
  if (e.target.closest(".selling_plan_fields")) {
    AddToCartText();
  }
});

document.body.addEventListener("change", function (e) {
  if (e.target.closest(".options-selection__input-select")) {
    AddToCartText();
  }
});

const variantSelection = document.querySelector("variant-selection");
if (variantSelection) {
  variantSelection.addEventListener("variant-change", function (a) {
    // Defer so active section can sync to new variant first (e.g. after pack click)
    setTimeout(AddToCartText, 0);
  });
}

// BFCM: re-render the ATC price when the sale state (re)computes.
document.addEventListener("bfcm:sale-state", function () {
  setTimeout(AddToCartText, 0);
});

function AddToCartText() {
  var copy = "";
  const atcButton = document.querySelector(".atc-button--text");
  if (!atcButton) return;
  const defaultCtaText =
    atcButton.getAttribute("data-cta-text") || "Add to Cart";

  const isBundlePDP = document.body.classList.contains("essential-starter-bundle");
  const hasV2 = !!document.querySelector(".purchase-box-v2");

  if (isBundlePDP) {
    let price = atcButton?.getAttribute("data-cta-price") || "";
    price = price.replace(/\.00$/, "");
    copy = `Add To Bag &ndash; ${price}`;
  } else {
    let priceText = "";

    if (hasV2) {
      const activeRadio = document.querySelector(
        "section.selling_plan_theme_integration.active input[type='radio']:checked"
      );
      if (activeRadio) {
        // BFCM: radios carry the regular price; reprice via BFCMSale when active.
        const saleApi = window.BFCMSale;
        const activeSection = activeRadio.closest("section.selling_plan_theme_integration");
        const bfcmCents = function (rawPrice) {
          const cents = Math.round(parseFloat(String(rawPrice || "").replace(/[^0-9.]/g, "")) * 100);
          if (!saleApi || !activeSection || !Number.isFinite(cents)) return null;
          const offer = saleApi.offerForVariant(activeSection.dataset.variantId, cents, saleApi.product);
          return offer ? offer.saleCents : null;
        };
        if (activeRadio.dataset.radioType === "subscribe_and_save") {
          let allocPrice = parseFloat(activeRadio.getAttribute("data-allocation-price"));
          const saleCents = bfcmCents(allocPrice);
          if (saleCents !== null) allocPrice = saleCents / 100;
          if (allocPrice) {
            priceText = "$" + allocPrice.toFixed(2);
          }
        } else {
          priceText = activeRadio.getAttribute("data-variant-price") || "";
          const saleCents = bfcmCents(priceText);
          if (saleCents !== null) {
            const dollars = saleCents / 100;
            priceText = "$" + dollars.toFixed(2);
          }
        }
      }
    }

    if (
      document.querySelectorAll(
        ".one-time-container.radio-container input:checked"
      ).length
    ) {
      if (hasV2 && priceText) {
        copy = `${defaultCtaText} &mdash; ${priceText}`;
      } else {
        copy = defaultCtaText;
      }
      document.body.setAttribute("plan-choosen", "one_time");
    } else if (
      document.querySelectorAll(
        ".subscribe_container.radio-container input:checked"
      ).length
    ) {
      if (hasV2 && priceText) {
        copy = `Add Subscription To Cart &mdash; ${priceText}`;
      } else {
        copy = "Add subscription to cart";
      }
      document.body.setAttribute("plan-choosen", "subscription");
    }

    if (copy != "") {
      var atcCTA = document.querySelector(
        ".product-form__action-wrapper .product-form--atc-button"
      );

      if (atcCTA && atcCTA.querySelector(".atc-button--text")) {
        atcCTA.querySelector(".atc-button--text").innerHTML = copy;
      } else if (atcCTA) {
        atcCTA.innerHTML = copy;
      }
    }
  }
}

function FlavorOption() {
  if (
    document.querySelectorAll(
      'label.options-selection__select-label[data-variant-option-name="Flavor"]'
    ).length
  ) {
    document
      .querySelectorAll(
        'label.options-selection__select-label[data-variant-option-name="Flavor"]'
      )[0]
      .parentNode.classList.add("Flavor");
  }
}
